import { toast } from 'react-hot-toast';

const ERROR_MAP = {
  'Failed to fetch': 'Ошибка запроса',
  'Unauthorized': 'Ошибка авторизации',
  'Internal Server Error': 'Ошибка сервера',
  'Bad Request': 'Некорректный запрос',
  'Not Found': 'Не найдено',
  'Forbidden': 'Доступ запрещен',
};

export function showError(error) {
  const message = typeof error === 'string' ? error : error?.message;
  console.error(error);
  toast.error(ERROR_MAP[message] || message || 'Произошла ошибка');
}
